<template>
	<div
		class="bg-purple-900 bg-gradient-to-b from-gray-900 via-gray-900 to-purple-800 leading-5 w-full flex justify-center overflow-hidden min-h-screen">
		<div
			class="flex-col flex self-center md:px-14 sm:max-w-4xl md:max-w-md z-10">
			<div class="self-start hidden lg:flex flex-col text-gray-300">
				<h1 class="my-3 font-semibold text-4xl">Join us now!</h1>
				<p class="pr-3 text-sm opacity-75">
					Here is Pass2Peer, your one stop for sharing materials to peers and
					help them out.
					<br />
					Signup now!
				</p>
			</div>
		</div>
		<div class="flex justify-center self-center h-full w-11/12 md:w-auto z-10">
			<div class="py-12 px-8 md:px-12 bg-white mx-auto rounded-3xl w-96">
				<div class="mb-7">
					<h3 class="font-semibold text-2xl text-gray-800">Sign Up</h3>
					<p class="text-gray-400">
						Already have an account?
						<router-link
							to="/login"
							class="text-sm text-purple-700 hover:text-purple-700">
							Log in
						</router-link>
					</p>
				</div>
				<form
					class="space-y-6"
					@submit.prevent="handleSubmit()">
					<div class="">
						<input
							v-model="username"
							class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
							type="text"
							autocomplete="on"
							placeholder="Username" />
					</div>
					<div class="">
						<input
							v-model="email"
							class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
							type="email"
							autocomplete="on"
							placeholder="Email" />
					</div>
					<div
						class="relative"
						x-data="{ show: true }">
						<input
							v-model="password"
							autocomplete="on"
							placeholder="Set Password"
							:type="!show ? 'password' : 'text'"
							class="text-sm text-black px-4 py-3 rounded-lg w-full bg-gray-200 focus:bg-gray-100 border border-gray-200 focus:outline-none focus:border-purple-400" />
					</div>
					<div>
						<button
							type="submit"
							class="w-full flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
							Sign up
						</button>
					</div>
				</form>
				<div class="mt-7 text-center text-gray-500 text-xs">
					<span>Copyright © 2022</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { store } from '@/components/store'

export default {
	name: 'Signup',
	data() {
		return {
			show: true,
			username: '',
			email: '',
			password: ''
		}
	},
	methods: {
		async handleSubmit() {
			const data = {
				username: this.username,
				email: this.email,
				password: this.password
			}
			const res = await axios.post('auth/signup', data)
			if (res.status === 201) {
				localStorage.setItem('token', res.data.jwt)
				store.loggedIn = true
				this.$router.push('/')
				Vue.$toast.success('Registered successfully', { position: 'top' })
			} else Vue.$toast.error(res.data.message, { position: 'top' })
		}
	}
}
</script>